import { render, staticRenderFns } from "./MyCoach.vue?vue&type=template&id=5e8789ad&"
import script from "./MyCoach.vue?vue&type=script&lang=js&"
export * from "./MyCoach.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/coachingclub/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5e8789ad')) {
      api.createRecord('5e8789ad', component.options)
    } else {
      api.reload('5e8789ad', component.options)
    }
    module.hot.accept("./MyCoach.vue?vue&type=template&id=5e8789ad&", function () {
      api.rerender('5e8789ad', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/vue/components/LockerRoom/SubPages/MyCoach.vue"
export default component.exports